export class ApplyFilterAction {
    public static readonly type = '[JobsPlacements] Apply filter';

    constructor(public filterId: number | null) { }
}
